export const previewFrameBorder =
  'border-ds-primary-300 border-[5px] border-solid';
